/**
 * Resolves a member's graduation year for display.
 *
 * The roster carries two record shapes. Newer entries store class standing in
 * `year` ('1'-'5') and the graduation year in `gradyear` ('2027'). Older entries
 * predate `gradyear` and store the graduation year directly in `year` ('2024').
 * Reading `year` blindly printed "Class of 3" for every newer member; reading
 * `gradyear` blindly would blank the older ones. Prefer `gradyear`, fall back to
 * a `year` that is actually a year, and otherwise return null so the caller can
 * omit the line entirely rather than render a placeholder.
 */
const YEAR_PATTERN = /^(19|20)\d{2}$/;

export default function getGradYear(member) {
  if (!member) return null;

  const gradYear = String(member.gradyear || '').trim();
  if (YEAR_PATTERN.test(gradYear)) return gradYear;

  const legacyYear = String(member.year || '').trim();
  if (YEAR_PATTERN.test(legacyYear)) return legacyYear;

  return null;
}
